import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    paddingVertical: 10,
  },
  line: {
    paddingVertical: 8,
  },
  divider: {
    height: 1,
    backgroundColor: cloudLight,
    marginVertical: 8,
  },
});
